var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderNotry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3135_49913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14H4C4 11.2727 4.94733 11.2727 6.52667 11.2727C10 11.2727 7.33333 8.18182 7.33333 6.6936C7.33333 5.97921 7.61428 5.29409 8.11438 4.78894C8.61448 4.28379 9.29276 4 10 4C10.7072 4 11.3855 4.28379 11.8856 4.78894C12.3857 5.29409 12.6667 5.97921 12.6667 6.6936C12.6667 8.18182 10 11.2727 13.4733 11.2727C15.0527 11.2727 16 11.2727 16 14Z",
    fill: "#FBA12B",
    stroke: "#FBA12B",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16H15",
    stroke: "#FBA12B",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3135_49913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNotry);
export default __webpack_public_path__ + "static/media/order-notry.1005ccfa5f4f976300449e371d0145d9.svg";
export { ForwardRef as ReactComponent };